import { withPagination } from 'shared/table/hoc/withPagination';
import { CostCentreTable } from '../CostCentreTable/CostCentreTable';
import { Pageable } from 'shared/table/models/Pageable';
import { SearchCentroCostoRequest } from 'core/centrocosto/models/SearchCentroCostoRequest';
import { CentroCosto } from 'core/centrocosto/models/CentroCosto';
import { useCoreService } from 'core/services/useCoreService';
import { useEffect, useMemo } from 'react';
import { useDataFetcher } from 'shared/http';

const TableWithPagination = withPagination<CentroCosto>(CostCentreTable);

const DEFAULT_NO_RESULT_MESSAGE =
  'No se encontraron centros de costos que concuerden con los parámetros de la búsqueda';

export const CostCentreTableWithPagination = (props: {
  searchParams: SearchCentroCostoRequest;
  reloadToken?: number;
  showButtons?: boolean;
  onDelete?: (value: CentroCosto) => void;
  noResultsMessage?: string;
}) => {
  const coreService = useCoreService();
  const [centroCostos, fetchCentroCostos] = useDataFetcher<Pageable<CentroCosto>>();

  const filtrosEstables = useMemo(() => {
    return props.searchParams;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(props.searchParams)]);

  useEffect(() => {
    fetchCentroCostos(() => coreService.getCostCentres(filtrosEstables));
  }, [coreService, fetchCentroCostos, filtrosEstables, props.reloadToken]);

  const onChangePaginationStatus = async (status: {
    pageNumber: number;
    pageSize: number;
  }): Promise<Pageable<CentroCosto>> => {
    props.searchParams.page = status.pageNumber;
    props.searchParams.size = status.pageSize;
    return coreService.getCostCentres(props.searchParams);
  };

  return (
    <TableWithPagination
      pageableInit={centroCostos.data}
      loadingState={centroCostos.isLoading}
      dataFetcherFunction={onChangePaginationStatus}
      noResultsMessages={props.noResultsMessage || DEFAULT_NO_RESULT_MESSAGE}
      showButtons={props.showButtons}
      onDelete={props.onDelete}
    ></TableWithPagination>
  );
};
